module.exports = __webpack_public_path__ + "static/media/isItWorthToPlay.dc4e7a28.jpg";